
import React from 'react';
import { RefreshCw } from 'lucide-react';
import SunStatusIndicator from '@/components/SunStatusIndicator';
import { SunStatus } from '@/types/terrace';

interface TerraceImageSectionProps {
  photoUrl?: string;
  name: string;
  sunStatus: SunStatus;
  isSunStatusUpdating: boolean;
}

const TerraceImageSection = ({
  photoUrl,
  name,
  sunStatus,
  isSunStatusUpdating
}: TerraceImageSectionProps) => {
  const displayImage = photoUrl || 'https://images.unsplash.com/photo-1500673922987-e212871fec22';
  
  const isFromStorageBucket = photoUrl?.includes('terrace-photos');
  
  return (
    <div className="h-[300px] md:h-[400px] relative rounded-lg overflow-hidden">
      <img 
        src={displayImage} 
        alt={name} 
        className="w-full h-full object-cover" 
      />
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
        <SunStatusIndicator status={sunStatus} className="mb-1" />
        {isFromStorageBucket && (
          <div className="flex items-center text-xs text-white/70 mb-1">
            <span className="bg-green-500/20 text-green-200 px-2 py-1 rounded text-xs">
              Storage Photo
            </span>
          </div>
        )}
        {isSunStatusUpdating && (
          <div className="flex items-center text-xs text-white/70 mt-1">
            <RefreshCw className="w-3 h-3 mr-1 animate-spin" />
            Updating sun status...
          </div>
        )}
      </div>
    </div>
  );
};

export default TerraceImageSection;
